import { render } from "./ProfileAccountNavigation.vue?vue&type=template&id=5e50d316&scoped=true"
import script from "./ProfileAccountNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileAccountNavigation.vue?vue&type=script&lang=js"

import "./ProfileAccountNavigation.vue?vue&type=style&index=0&id=5e50d316&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e50d316"]])

export default __exports__